import _ from "lodash";

type Error = string | null | Record<string, any>;

export function ErrorField(props: { error: Error }) {
	if (!props.error) {
		return null;
	}
	if (typeof props.error === "string") {
		return <pre>{props.error}</pre>;
	}
	return (
		<pre
			style={{
				fontSize: "18px",
				backgroundColor: "rgba(0, 0, 0, 0.08)",
				padding: "8px",
				borderRadius: "10px",
			}}
		>
			{_.toPairs(props.error).map(([key, value]) => (
				<div key={key} style={{ marginLeft: "1em" }}>
					<strong>{key}:</strong>
					<ErrorField error={value} />
				</div>
			))}
		</pre>
	);
}
